import BaseCadastro from "components/BaseCadastro";
import { Label } from "components/input/Label";
import Acao from "model/administracao/cadastro/Acao";
import Conta from "model/administracao/cadastro/Conta";
import Modulo from "model/administracao/cadastro/Modulo";
import Perfil from "model/administracao/cadastro/Perfil";
import ItemDashboard from "model/dashboard/ItemDashboard";
import PerfilItemDashboard from "model/dashboard/PerfilItemDashboard";
import { Checkbox } from "primereact/checkbox";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { InputText } from "primereact/inputtext";
import { TreeTable, TreeTableSelectionEvent, TreeTableSelectionKeysType } from "primereact/treetable";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import ContaService from "service/administracao/cadastro/ContaService";
import PerfilService from "service/administracao/cadastro/PerfilService";
import DashboardService from "service/dashboard/DashboardService";

const perfilService = new PerfilService();
const contaService = new ContaService();
const dashboardService = new DashboardService();

export default function PerfilCadastro() {

    const [queryParameters] = useSearchParams();

    const { setError, formState: { errors }, register, clearErrors } = useForm();

    const [perfil, setPerfil] = useState<Perfil>(new Perfil());
    const [modulos, setModulos] = useState<Modulo[]>([]);
    const [acoes, setAcoes] = useState<Acao[]>([]);
    const [itensDashboard, setItensDashboard] = useState<ItemDashboard[]>([]);
    const [conta, setConta] = useState<Conta>(new Conta());
    const [titulo, setTitulo] = useState<string>('Perfil');
    const [nodes, setNodes] = useState<any[]>([]);
    const [selectedNodes, setSelectedNodes] = useState<TreeTableSelectionKeysType | null>(null);
    const [allSelected, setAllSelected] = useState<boolean>(false);

    useEffect(() => {
        const idConta = queryParameters.get('idConta');
        if (window.location.pathname.includes('/cadastrar')) {
            perfilService.modulosAcoes(idConta ? parseInt(idConta) : undefined).then(modulosParam => {
                setModulos(modulosParam);
                defineNodes(modulosParam, perfil);
                let acoes: Acao[] = [];
                modulosParam.map(modulo => {
                    modulo.acoes.map(acao => acoes.push(acao))
                });
                setAcoes(acoes);
            });
        }
    }, [])

    function afterLoad(perfilParam: Perfil) {
        const idConta = queryParameters.get('idConta');
        if (idConta) {
            contaService.consultar(parseInt(idConta)).then(contaParam => {
                setConta(contaParam);
                setTitulo(`Perfil da Conta ${contaParam.nome}`);
            });
        }

        perfilService.modulosAcoes(idConta ? parseInt(idConta) : null).then(modulosParam => {
            setModulos(modulosParam);
            defineNodes(modulosParam, perfilParam);
            let acoes: Acao[] = [];
            modulosParam.map(modulo => {
                modulo.acoes.map(acao => acoes.push(acao))
            });
            setAcoes(acoes);
        });
        perfilService.itensDashboard(idConta ? parseInt(idConta) : null).then(itensDashboardParam => {
            setItensDashboard(itensDashboardParam);
        }).catch(() => {
            setItensDashboard([]);
        });
    }

    function defineNodes(modulos: Modulo[], perfilParam: Perfil) {

        let nodesLocal: any[] = [];
        let selectedNodesLocal: any = {};
        let allSelectedLocal = true;

        modulos.map(modulo => {

            let node = {
                key: modulo.id + 1000000,
                data: {
                    nome: modulo.nome,
                    descricao: modulo.descricao,
                    sigla: "",
                },
                children: []
            }

            let partialCheckedLocal = false;
            let checkedLocal = false;

            modulo.acoes.map((acao, indexAcao) => {
                node.children.push({
                    key: acao.sigla,
                    data: {
                        nome: acao.nome,
                        descricao: acao.descricao,
                        sigla: acao.sigla,
                    },
                } as never);
                if (perfilParam.acoes && (perfilParam.acoes.findIndex((acaoPerfil: Acao) => acaoPerfil.sigla === acao.sigla)) > -1) {
                    selectedNodesLocal = { ...selectedNodesLocal, [acao.sigla]: { checked: true, partialChecked: false } };

                    if (indexAcao === 0) {
                        checkedLocal = true;
                    } else if (!checkedLocal) {
                        partialCheckedLocal = true;
                    }

                } else {
                    if (checkedLocal) {
                        partialCheckedLocal = true;
                        checkedLocal = false;
                    }
                }
            });

            if (!checkedLocal) {
                allSelectedLocal = false;
            }
            selectedNodesLocal = { ...selectedNodesLocal, [modulo.id + 1000000]: { checked: checkedLocal, partialChecked: partialCheckedLocal } };
            nodesLocal.push(node);
        });

        setAllSelected(allSelectedLocal);
        setSelectedNodes(selectedNodesLocal);
        setNodes(nodesLocal);
    }

    function validar() {

        if (!perfil.nome) {
            setError("nome", { type: "manual", message: "Nome é obrigatório" }, { shouldFocus: true })
            return false;
        }
        return true;
    }

    useEffect(() => {
        let acoesLocais: Acao[] = [];
        if (selectedNodes) {
            let acoesSelecionadas = Object.keys(selectedNodes);
            acoesSelecionadas.map(key => {
                acoes.map(acao => {
                    if (acao.sigla === key) {
                        acoesLocais.push(acao);
                    }
                });
            });
            setPerfil({ ...perfil, acoes: acoesLocais });

            let AllSelectedLocal = true;

            acoes.map(acao => {
                if (acoesLocais.findIndex(acaoLocal => acaoLocal.sigla === acao.sigla) === -1) {
                    AllSelectedLocal = false;
                }
            });
            setAllSelected(AllSelectedLocal);
        }


    }, [selectedNodes]);

    function onChangeAllSelect(value: boolean) {
        if (value) {
            let selectedNodesLocal: any = {};
            nodes.map(node => {
                node.children.map((child: any) => {
                    selectedNodesLocal = { ...selectedNodesLocal, [child.data.sigla]: { checked: true, partialChecked: false } };
                });
                selectedNodesLocal = { ...selectedNodesLocal, [node.key]: { checked: true, partialChecked: false } };
            });
            setSelectedNodes(selectedNodesLocal);
        } else {
            setSelectedNodes({});
        }
        setAllSelected(value);


    }

    return (

        <BaseCadastro model={perfil} service={perfilService} setModel={(value: Perfil) => setPerfil(value)} validar={() => validar()} afterLoad={afterLoad} urlService="/perfil" pathCadastro="/perfil" tituloPagina={'Perfil'}>

            {titulo ?
                <div className="row">
                    <label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">{titulo}</label>
                </div>
                : null}

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Nome</Label>
                <div className="col-sm-12">
                    <InputText required value={perfil.nome} style={{ width: '100%' }}
                        className={errors.nome ? "p-invalid" : ""}
                        {...register("nome", {
                            onChange: (e) => {
                                clearErrors("nome");
                                setPerfil({ ...perfil, nome: e.target.value })
                            }
                        })}
                    />
                </div>
                {errors.nome && errors.nome.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.nome?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12">Descrição</Label>
                <div className="col-sm-12">
                    <InputText required value={perfil.descricao} onChange={(e) => setPerfil({ ...perfil, descricao: e.target.value })} style={{ width: '100%' }} />
                </div>
            </div>

            <div className="row">
                <div className="col-sm-12">

                    <TreeTable
                        header='Ações'
                        value={nodes}
                        selectionMode={"checkbox"}
                        tableStyle={{ minWidth: '50rem' }}
                        selectionKeys={selectedNodes}
                        onSelectionChange={(e: TreeTableSelectionEvent) => setSelectedNodes(e.value)}
                    >
                        <Column field="nome" header={<div style={{ marginLeft: 40 }}>
                            <Checkbox checked={allSelected} onChange={(e) => onChangeAllSelect(e.checked as boolean)} />
                            <span style={{ marginLeft: 8 }}>Nome</span>

                        </div>} style={{ width: 420 }} expander></Column>
                        <Column field="descricao" header="Descrição"></Column>
                        <Column field="sigla" header="Sigla" style={{ width: 350 }}></Column>
                    </TreeTable>

                </div>
            </div>

            <div className="row">
                <div className="col-sm-12">

                    <DataTable
                        emptyMessage="Nenhum registro encontrado"
                        header='Itens do dashboard'
                        value={itensDashboard}
                        selectionMode="multiple"
                        selection={perfil.itensDashboard?.map(item => new ItemDashboard(item.codigoItem)) || []}
                        onSelectionChange={(e) => setPerfil({
                            ...perfil, itensDashboard: (e.value as any[]).map(item => {
                                let indice = perfil.itensDashboard?.findIndex(itemPerfil => itemPerfil.codigoItem === item.codigoItem);
                                if (indice !== -1) {
                                    return new PerfilItemDashboard(perfil.itensDashboard[indice].id, item.codigoItem);
                                }
                                return new PerfilItemDashboard(0, item.codigoItem);
                            })
                        })}
                        dataKey="codigoItem"
                        tableStyle={{ minWidth: '50rem' }}
                    >
                        <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column>
                        <Column field="nome" header="Nome"></Column>
                        <Column header="tipo" body={(rowData) => dashboardService.getTipoItem(rowData.tipo)}></Column>
                    </DataTable>

                </div>
            </div>

        </BaseCadastro>
    )
}
